import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export function ScrollViewAnimation() {
  const sections = document.querySelectorAll("[data-animate]");
  if (!sections.length) return null;

  const triggers = [];

  sections.forEach((section) => {
    const items = section.querySelectorAll("[data-animate-item]");
    const targets = items.length ? items : section;

    gsap.set(targets, {
      transformOrigin: "center center",
      autoAlpha: 0,
      scale: 0.4,
      force3D: true,
    });

    const trigger = ScrollTrigger.create({
      trigger: section,
      start: "top 95%",
      once: true,
      onEnter: () => {
        gsap.to(targets, {
          autoAlpha: 1,
          scale: 1,
          duration: 1,
          stagger: 0.2,
          ease: "elastic.out(1, 0.6)",
          overwrite: "auto",
        });
      },
    });

    triggers.push(trigger);
  });

  return () => {
    triggers.forEach((t) => t.kill());
  };
}
